const agriPaginationSx = {
  "& .MuiPaginationItem-root": {
    color: "#ffffff",
    borderColor: "rgba(255, 255, 255, 0.72)",
    backgroundColor: "transparent",
    fontWeight: 700,
    "&:hover": {
      color: "#ffffff",
      borderColor: "#ffffff",
      backgroundColor: "rgba(255, 255, 255, 0.1)",
    },
    "&.Mui-selected": {
      color: "#ffffff",
      borderColor: "#ffffff",
      backgroundColor: "rgba(56, 189, 248, 0.28)",
      "&:hover": {
        backgroundColor: "rgba(56, 189, 248, 0.38)",
      },
    },
    "&.Mui-disabled": {
      color: "rgba(255, 255, 255, 0.5)",
      borderColor: "rgba(255, 255, 255, 0.28)",
      opacity: 1,
    },
  },
  "& .MuiPaginationItem-ellipsis": {
    borderColor: "transparent",
  },
  "& .MuiSvgIcon-root": {
    color: "inherit",
  },
};

export default agriPaginationSx;
